import { FormProvider, useForm } from 'react-hook-form';

import { Alert, Field, Flex, Textarea, Typography } from 'shared';
import { VARIANTS } from 'shared_DEPRECATED/components/Button';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

import { SessionsModalSection } from 'features/sessions/components/Modal';

import { ModalBody, ModalFooter, ModalHeader } from 'shared/components/Modal';
import { ModalButton } from 'shared/components/Modal/ModalButton';

type CoachSessionCancelModalProps = {
  onSubmit: ({ reason }: { reason: string }) => void;
};

export const CoachSessionCancelModal = ({
  onSubmit,
}: CoachSessionCancelModalProps) => {
  const formMethods = useForm({
    defaultValues: {
      reason: '',
    },
  });

  const { formState } = formMethods;

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={formMethods.handleSubmit(onSubmit)}>
        <ModalHeader>
          <Typography as="h3" type="body" fontWeight="semibold" color="black">
            Cancel session
          </Typography>
        </ModalHeader>
        <ModalBody>
          <SessionsModalSection
            title="Please provide a reason for session cancellation"
            dataTestid="cancel-session-reason"
          >
            <Flex flexDirection="column" gap={3}>
              <Alert
                status="warning"
                icon={
                  <Icon name={iconNames.warning} width="20px" height="20px" />
                }
              >
                You won't be able to schedule this session again
              </Alert>
              <Field invalid={!!formState.errors.reason}>
                <Textarea
                  placeholder="Write the reason for cancellation here"
                  {...formMethods.register('reason', {
                    setValueAs: (v) => v.trim(),
                    required: true,
                  })}
                  data-testid="cancel-session-modal-reason-field"
                />
              </Field>
            </Flex>
          </SessionsModalSection>
        </ModalBody>
        <ModalFooter>
          <ModalButton variant="outline">Cancel</ModalButton>
          <ModalButton
            type="submit"
            color={VARIANTS.PRIMARY}
            shouldClose={formState.isValid}
            dataTestid="cancel-session-bnt"
          >
            Confirm
          </ModalButton>
        </ModalFooter>
      </form>
    </FormProvider>
  );
};
